// src/utils/tokenUtils.js

// Accurate token estimation based on character count
// Most models: ~4 chars per token for regular text, ~3.5 for code
export const estimateTokens = (text, modelId = '') => {
  try{
  let parse=JSON.parse(text);
  if(typeof parse == 'string')
  {
    text=parse;
  }
 }catch(e){
    // Not JSON, proceed as normal string
  }
  if (!text || typeof text !== 'string'){
    text=JSON.stringify(text);
  }
 

  if (!text || typeof text !== 'string') return 0;

  let charsPerToken = 4; // Default for most models

  // Check if text contains a lot of code (JSON, JS, HTML, CSS)
  const codePatterns = /[{}\[\];()="'`<>]/g;
  const codeMatches = (text.match(codePatterns) || []).length;
  const codeRatio = codeMatches / text.length;
  
  if (codeRatio > 0.1) {
    // High code content - tokens are denser
    charsPerToken = 3.5;
  }

  // Model-specific adjustments
  if (modelId && typeof modelId === 'string') {
    const lowerId = modelId.toLowerCase();
    if (lowerId.includes('claude')) {
      charsPerToken = codeRatio > 0.1 ? 3.5 : 4.0;
    } else if (lowerId.includes('gpt')) {
      charsPerToken = codeRatio > 0.1 ? 3.5 : 4.0;
    }
  }

  const estimatedTokens = Math.ceil(text.length / charsPerToken);
  console.log(`Token estimation: ${text.length} chars / ${charsPerToken} = ${estimatedTokens} tokens`);
  return estimatedTokens;
};



// Calculate cost for a conversation using backend model pricing
export const calculateMessageCost = (inputText = '', outputText = '', modelId = '') => {
  const modelsData = window.modelsCache || { models: [] };
  const modelData = modelsData.models.find(m => m.id === modelId);
  const pricing = modelData?.pricing || { input: 0.30, output: 0.30 };
  
  const inputTokens = estimateTokens(inputText, modelId);
  const outputTokens = estimateTokens(outputText, modelId);
  const totalTokens = inputTokens + outputTokens;

  // Use proper pricing per 1M tokens: (tokens / 1000000) * price_per_1M_tokens
  const inputCost = (inputTokens / 1000000) * pricing.input;
  const outputCost = (outputTokens / 1000000) * pricing.output;
  const totalCost = inputCost + outputCost;
  
  return {
    inputTokens,
    outputTokens,
    totalTokens,
    inputCost,
    outputCost,
    totalCost
  };
};

// Estimate cost before sending using backend model pricing
export const estimateMessageCost = (inputText = '', modelId = '') => {
  const modelsData = window.modelsCache || { models: [] };
  const modelData = modelsData.models.find(m => m.id === modelId);
  const pricing = modelData?.pricing || { input: 0.30, output: 0.30 };
  
  const inputTokens = estimateTokens(inputText, modelId);
  const estimatedOutputTokens = 5000;
  const totalTokens = inputTokens + estimatedOutputTokens;

  // Use proper pricing per 1M tokens: (tokens / 1000000) * price_per_1M_tokens
  const inputCost = (inputTokens / 1000000) * pricing.input;
  const outputCost = (estimatedOutputTokens / 1000000) * pricing.output;
  const totalCost = inputCost + outputCost;

  return {
    inputTokens,
    estimatedOutputTokens,
    totalTokens,
    inputCost,
    outputCost,
    totalCost
  };
};